<div
  *ngIf="formInput && editable && controlName && formInput.get(controlName)"
  class="form-field__body"
  [ngSwitch]="type"
  [formGroup]="formInput"
>
  <editor
    [init]="init"
    licenseKey="gpl"
    (onInit)="onEditorInit($event)"
    [formControlName]="controlName"
    class="w-100"
  >
  </editor>
</div>

<ng-template #mentionLoadingTpl>
  <div
    id="mention-loading"
    class="d-flex flex-column justify-content-center align-items-center"
  >
    <span
      class="spinner-border spinner-border-sm mb-1"
      aria-hidden="true"
    ></span>
    <span>{{ 'Common.Loading' | translate }}...</span>
  </div>
</ng-template>

<ng-template #mentionEmptyTpl>
  <div
    id="mention-empty-content"
    class="d-flex justify-content-center align-items-center"
  >
    <span translate>Common.NoResultsFound</span>
  </div>
</ng-template>
